import { type Components, type Theme } from "@mui/material/styles";

export const toggleButtonGroup: Components<Theme>["MuiToggleButtonGroup"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: "inline-flex",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 1.5,
      padding: theme.spacing(0.25),
      backgroundColor: theme.palette.background.paper,
      gap: theme.spacing(0.25),
    }),
    grouped: ({ theme }) => ({
      border: 0,
      borderRadius: theme.shape.borderRadius,
      "&:not(:first-of-type), &:first-of-type": {
        borderRadius: theme.shape.borderRadius,
      },
    }),
  },
};
